import { useZero } from "@rocicorp/zero/react";
import { type ReactNode, useCallback, useRef, useState } from "react";
import { sharedMutators } from "../../shared/mutators";
import { ConfirmModal } from "../components/ConfirmModal";
import { navigate, routes } from "../lib/urls";

export function useDeleteLastBranch() {
  const z = useZero();
  const [branchId, setBranchId] = useState<string | null>(null);
  const spaceIdRef = useRef("");

  const confirm = useCallback((id: string, spaceId: string) => {
    spaceIdRef.current = spaceId;
    setBranchId(id);
  }, []);

  const modal: ReactNode = (
    <ConfirmModal
      open={branchId !== null}
      onClose={() => setBranchId(null)}
      onConfirm={() => {
        if (branchId) {
          z.mutate(sharedMutators.deleteBranch({ branchId }));
        }
        const spaceId = spaceIdRef.current;
        setBranchId(null);
        navigate(routes.space, { spaceId });
      }}
      title="Delete workflow"
      description="This is the only branch. Deleting it will also delete the workflow."
      confirmLabel="Delete workflow"
      destructive
    />
  );

  return { confirm, modal };
}
